import { StateSchema } from "@/app/providers/StoreProvider";

export const getReadingDetailsIsLoading = (state: StateSchema) =>
  state.readingDetails?.readingDetailsIsLoading || false;
export const getReadingDetailsData = (state: StateSchema) => state.readingDetails?.readingDetailsData;
export const getReadingDetailsError = (state: StateSchema) => state.readingDetails?.readingDetailsError;
